import * as React from 'react';
const MinusSvg = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} {...props}>
    <path d="M14.25 9.75H3.75a.75.75 0 1 1 0-1.5h10.5a.75.75 0 1 1 0 1.5Z" />
  </svg>
);
export default MinusSvg;
